import ReactGA from 'react-ga4';

// GA4 配置
// 使用您的 GA4 测量 ID
// 如果有多个域名:
// 1. 在 GA4 中为每个域名创建单独的数据流
// 2. 使用其中一个数据流的测量 ID
// GA4 会自动根据 hostname 区分不同域名的数据
const GA_MEASUREMENT_ID = 'G-KMC48C8700'; // GA4 测量 ID

// 初始化 GA4
export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

// 页面访问跟踪
export const trackPageView = () => {
  const hostname = window.location.hostname;
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname,
    title: document.title,
    domain: hostname // 添加域名参数
  });
};

// 分享行为跟踪
export const trackShare = (type, content = '') => {
  const hostname = window.location.hostname;
  ReactGA.event({
    category: 'Share',
    action: `share_${type}`,
    label: content,
    domain: hostname,
    share_type: type
  });
};

// 分享内容跟踪
export const trackGameContent = (gameState) => {
  const hostname = window.location.hostname;
  // 将游戏状态转换为 JSON 字符串，然后进行 base64 编码
  const gameStateStr = JSON.stringify(gameState);
  const encodedGameState = btoa(encodeURIComponent(gameStateStr));
  
  ReactGA.event({
    category: 'GameContent',
    action: 'share_game_content',
    label: encodedGameState,
    domain: hostname,
    game_content: encodedGameState // 添加一个专门的参数来存储编码后的内容
  });
}; 